export default {
  getBanners(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/homes/banners-homes")
        .then((response) => {
          context.commit("setBanners", response.data.results);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getCollections(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/homes/collections")
        .then((response) => {
          context.commit("setCollections", response.data.results);
          context.commit("setPagination", {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          });
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getContentCollections(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/homes/?limit=100")
        .then((response) => {
          context.commit("setContentCollections", response.data.results);
          context.commit("setPagination", {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
          });
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
